import * as React from "react";
import { Input } from "react-ui";
import { ColumnStack, Fit } from "@skbkontur/react-stack-layout";
import { InputProps } from "@skbkontur/react-ui/cjs/components/Input/Input";

import { Tooltip } from "../../Internals/Tooltip/Tooltip";

import { LawCaption, LawName } from "./TaxRebate.styles";

export interface TaxRebateLawProps {
    lawName?: string;
    lawWidth: number;
    lawInput: React.RefObject<Input>;
    lawInputProps: InputProps;
}

export function TaxRebateLaw(props: TaxRebateLawProps): JSX.Element {
    const { lawName, lawWidth, lawInput, lawInputProps } = props;

    return (
        <Fit>
            <ColumnStack gap={1}>
                <Tooltip useWrapper={false} pos="top left" trigger={lawName ? "hover&focus" : "closed"} value={lawName}>
                    <LawCaption style={{ width: lawWidth }}>
                        <LawName>{lawName}</LawName>
                    </LawCaption>
                </Tooltip>
                <Fit>
                    <Input ref={lawInput} {...lawInputProps} />
                </Fit>
            </ColumnStack>
        </Fit>
    );
}
